import script from "./HeadCell.vue?vue&type=script&lang=js"
export * from "./HeadCell.vue?vue&type=script&lang=js"

import "./HeadCell.vue?vue&type=style&index=0&id=9b795e24&lang=scss&scoped=true"
script.__scopeId = "data-v-9b795e24"

export default script